import { render, staticRenderFns } from "./DistributionControl.vue?vue&type=template&id=2fc7000e"
import script from "./DistributionControl.vue?vue&type=script&lang=js"
export * from "./DistributionControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports